import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'
import {isLangEN} from '_metronic/helpers/GeneralHelper'

export function CanteenMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/canteen/'

  const menuPlacement = isLangEN() ? 'bottom-start' : 'bottom-end'

  return (
    <>
      {/* HOME */}
      <MenuItem title={t('MENU.HOME')} to={`${base}home`} />

      {/* CANTEEN ITEM */}
      {hasPermission('canteen-item-list') && (
        <MenuItem title={t('MENU.CANTEEN_ITEM')} to={`${base}item`} />
      )}

      {/* ITEM STOCK */}
      {hasPermission('canteen-item-stock-list') && (
        <MenuItem title={t('MENU.CANTEEN_ITEM_STOCK')} to={`${base}item-stock`} />
      )}

      {/* PURCHASE */}
      {(hasPermission('canteen-purchase-create') || hasPermission('canteen-purchase-list')) && (
        <MenuInnerWithSub
          title={t('MENU.PURCHASE')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('canteen-purchase-create') && (
            <MenuItem
              to={`${base}purchase-create/0`}
              fontIcon='fas fa-file-invoice'
              title={t('MENU.PURCHASE')}
            />
          )}

          {hasPermission('canteen-purchase-list') && (
            <MenuItem
              to={`${base}purchase-list`}
              fontIcon='fas fa-list'
              title={t('MENU.PURCHASE_LIST')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* SALE */}
      {(hasPermission('canteen-sale-create') || hasPermission('canteen-sale-list')) && (
        <MenuInnerWithSub
          title={t('MENU.SALE')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('canteen-sale-create') && (
            <MenuItem
              to={`${base}sale-create/0`}
              fontIcon='fas fa-cash-register'
              title={t('MENU.SALE')}
            />
          )}

          {hasPermission('canteen-sale-list') && (
            <MenuItem to={`${base}sale-list`} fontIcon='fas fa-list' title={t('MENU.SALE_LIST')} />
          )}
        </MenuInnerWithSub>
      )}

      {/* REPORT */}
      {(hasPermission('canteen-purchase-report') || hasPermission('canteen-sale-report')) && (
        <MenuInnerWithSub
          title={t('MENU.REPORT')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('canteen-purchase-report') && (
            <MenuItem
              to={`${base}purchase-report`}
              fontIcon='fas fa-file-invoice'
              title={t('MENU.PURCHASE_REPORT')}
            />
          )}

          {hasPermission('canteen-sale-report') && (
            <MenuItem
              to={`${base}sale-report`}
              fontIcon='fas fa-cash-register'
              title={t('MENU.SALE_REPORT')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* CASH TRANSFER */}
      {hasPermission('canteen-item-cash-transfer') && (
        <MenuItem title={t('MENU.CASH_TRANSFER')} to={`${base}cash-transfer-list`} />
      )}
    </>
  )
}
